import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { normalizeFields } from './utils/fields';
/**
 * Immutable data sort by specified fields.
 */
export var SortBy = function SortBy(options) {
  var _options$fields = options.fields,
    F = _options$fields === void 0 ? [] : _options$fields;
  var normalizedF = normalizeFields(F, true);
  return function (data) {
    var comparator = function comparator(a, b) {
      return normalizedF.reduce(function (ret, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          field = _ref2[0],
          _ref2$ = _ref2[1],
          order = _ref2$ === void 0 ? true : _ref2$;
        if (ret !== 0) {
          return ret;
        }
        if (order) {
          return a[field] < b[field] ? -1 : +(a[field] !== b[field]);
        } else {
          return a[field] > b[field] ? -1 : +(a[field] !== b[field]);
        }
      }, 0);
    };
    return _toConsumableArray(data).sort(comparator);
  };
};
SortBy.props = {};